import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd20ab02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "separator"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "comma" }, ",  ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["line-type-chip", [$props.disabled, { small: $props.isSmallSize }, $setup.lineTypeClass]])
  }, [
    _createElementVNode("span", null, _toDisplayString($props.lineTypeName), 1 /* TEXT */),
    ($setup.lineSets.length || $setup.driveDatesItems.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " / "))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.driveDatesItems, (dateItem, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: "drive-date-item"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dateItem.days, (day, dayIndex) => {
            return (_openBlock(), _createElementBlock("span", {
              key: dayIndex,
              class: _normalizeClass(["day-text", [$setup.lineTypeClass, { today: day.isToday }]])
            }, [
              _createTextVNode(_toDisplayString(day.text), 1 /* TEXT */),
              (dayIndex < dateItem.days.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */)),
          (index < $setup.driveDatesItems.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(dateItem.separator), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (index < $setup.driveDatesItems.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", "))
            : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lineSets, (lineSet) => {
      return (_openBlock(), _createElementBlock("span", {
        key: lineSet.name,
        class: _normalizeClass(["line-set-text", [$setup.lineTypeClass, { today: lineSet.isToday }]])
      }, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(lineSet.displayText), 1 /* TEXT */)
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}